import React, { useEffect, useState } from "react";
import axios from "axios";
import "./delivered.css";

const API_BASE = process.env.REACT_APP_API_BASE;
const PAGE_SIZE = 10;

function getAuthToken() {
  return localStorage.getItem("access") || localStorage.getItem("access_token");
}

export default function DeliveredOrdersTable() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchDeliveredOrders(currentPage);
    // eslint-disable-next-line
  }, [currentPage]);

  const fetchDeliveredOrders = async (page) => {
    const token = getAuthToken();
    if (!token) {
      setError("Please login first");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/orders/delivered/?page=${page}&page_size=${PAGE_SIZE}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      // Normalize order data and user fields
      setOrders(
        (res.data.results || []).map((order) => ({
          ...order,
          customer_name: order.customer_name || order.user?.username || "N/A",
          customer_phone: order.customer_phone || order.user?.phone || "-",
          cart: order.cart || { items: order.items || [] },
          created_at: order.created_at,
        })),
      );
      setTotalCount(
        typeof res.data.count === "number"
          ? res.data.count
          : res.data.results?.length || 0,
      );
      setError("");
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.clear();
        setError("Session expired. Please login again.");
        window.location.href = "/admin/login";
      } else if (err.response?.status === 403) {
        setError("You are not allowed to view delivered orders.");
      } else {
        setError("Failed to load delivered products.");
      }
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));

  if (loading)
    return <p className="state-text">Loading delivered products...</p>;
  if (error) return <p className="state-text error">{error}</p>;

  return (
    <div className="table-page">
      <h2 className="page-title">Delivered Products</h2>
      <div className="table-wrapper">
        <table className="delivered-table">
          <thead>
            <tr>
              <th>Order #</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Product</th>
              <th>Image</th>
              <th>Qty</th>
              <th>Size</th>
              <th>Color</th>
              <th>Price</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td
                  colSpan="10"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No delivered orders found
                </td>
              </tr>
            ) : (
              orders.map((order) =>
                (order.cart.items || []).map((item) => (
                  <tr key={order.id + "-" + item.id}>
                    <td>{order.id}</td>
                    <td>{order.customer_name}</td>
                    <td>{order.customer_phone}</td>
                    <td>{item.product?.name || "-"}</td>
                    <td>
                      {item.product?.product_images?.length > 0 ? (
                        <img
                          src={
                            item.product.product_images[0].image.startsWith(
                              "http",
                            )
                              ? item.product.product_images[0].image
                              : `${API_BASE.replace("/api/v1", "")}${item.product.product_images[0].image}`
                          }
                          alt="product"
                          style={{
                            maxWidth: 60,
                            maxHeight: 60,
                            borderRadius: 4,
                            background: "#eee",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: 55,
                            height: 55,
                            background: "#eee",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 4,
                            fontSize: 11,
                            color: "#bbb",
                          }}
                        >
                          No Image
                        </div>
                      )}
                    </td>
                    <td>{item.quantity}</td>
                    <td>{item.size || "-"}</td>
                    <td>{item.color || "-"}</td>
                    <td>
                      ETB{" "}
                      {item.product?.price != null ? item.product.price : "-"}
                    </td>
                    <td>
                      {order.created_at
                        ? new Date(order.created_at).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                )),
              )
            )}
          </tbody>
        </table>
      </div>
      {/* PAGINATION */}
      <div
        className="pagination-controls"
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "2rem",
        }}
      >
        <button
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          disabled={currentPage <= 1}
        >
          Previous
        </button>
        <span>
          Page <b>{currentPage}</b> of <b>{totalPages}</b>
        </span>
        <button
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          disabled={currentPage >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}
